import FormSkeleton from "../FormSkeleton/index";

const DetailFormSkeleton = () => {
    return (
        <FormSkeleton>
            <FormSkeleton.FieldSkeleton fieldWidth="30%" />
            <FormSkeleton.RadioButtonSkeleton options={3} />
            <FormSkeleton.FieldGroupSkeleton fields={6} columns={3} />
        </FormSkeleton>
    );
}

export default DetailFormSkeleton;